export const getImageByWidth = (imageList, minWidth) => {
  // Sort array by width from smallest to largest, then return the first
  // item width width at least equal to minWidth. If no items match,
  // return the largest available.
  const imagesSorted = [...imageList].sort((a, b) => a.width - b.width);
  const [largest] = imagesSorted.slice(-1);
  return imagesSorted.find(({ width }) => width >= minWidth) || largest;
};



// WEBPACK FOOTER //
// ./src/utils/api.js